import { useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router";
import { Layout } from "./components/Layout.js";
import { useSession } from "./lib/auth.js";
import { startSync, stopSync } from "./lib/sync.js";
import { Activity, Archived, Trash } from "./pages/Admin.js";
import { Calendar } from "./pages/Calendar.js";
import { Completed } from "./pages/Completed.js";
import { FiltersLabels, FilterView, LabelView } from "./pages/FiltersLabels.js";
import { Focus } from "./pages/Focus.js";
import { Habits } from "./pages/Habits.js";
import { Login, ResetPassword } from "./pages/Login.js";
import { Browse } from "./pages/Browse.js";
import { Matrix } from "./pages/Matrix.js";
import { Productivity } from "./pages/Productivity.js";
import { ProjectPage } from "./pages/Project.js";
import { Search } from "./pages/Search.js";
import { Settings } from "./pages/Settings.js";
import { Today } from "./pages/Today.js";
import { Upcoming } from "./pages/Upcoming.js";

export function App() {
  const { data: session, isPending } = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (session) startSync();
    else stopSync();
  }, [session]);

  useEffect(() => {
    const onUnauthorised = () => navigate("/login");
    window.addEventListener("todoer:unauthorised", onUnauthorised);
    return () => window.removeEventListener("todoer:unauthorised", onUnauthorised);
  }, [navigate]);

  if (isPending) return <div className="grid h-full place-items-center text-body text-text-faint" role="status">Loading…</div>;

  return (
    <Routes>
      <Route path="/login" element={session ? <Navigate to="/today" replace /> : <Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route element={session ? <Layout /> : <Navigate to="/login" replace />}>
        <Route index element={<Navigate to="/today" replace />} />
        <Route path="/today" element={<Today />} />
        <Route path="/inbox" element={<ProjectPage inbox />} />
        <Route path="/upcoming" element={<Upcoming />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/project/:id" element={<ProjectPage />} />
        <Route path="/filters" element={<FiltersLabels />} />
        <Route path="/label/:id" element={<LabelView />} />
        <Route path="/filter/:id" element={<FilterView />} />
        <Route path="/search" element={<Search />} />
        <Route path="/completed" element={<Completed />} />
        <Route path="/matrix" element={<Matrix />} />
        <Route path="/habits" element={<Habits />} />
        <Route path="/focus" element={<Focus />} />
        <Route path="/productivity" element={<Productivity />} />
        <Route path="/activity" element={<Activity />} />
        <Route path="/trash" element={<Trash />} />
        <Route path="/archived" element={<Archived />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/settings/:section" element={<Settings />} />
        <Route path="/browse" element={<Browse />} />
      </Route>
      <Route path="*" element={<Navigate to="/today" replace />} />
    </Routes>
  );
}
